export const sflists = [
    {val: 'country' , desc: 'Country' },
    {val: 'state', desc: 'US State'}
];